import { useDispatch, useSelector } from "react-redux";
import { Button, message, Tooltip } from "antd";
import { getAISuggestion } from "../../../redux/trade-form/tradeFormSlice";
import useAISuggestion from "../hooks/useAISuggestion";
import styles from "../../../styles/shared/trade-form/TradeModal.module.css";
import React, { useRef } from "react";
import { MdInfo, MdRefresh } from "react-icons/md";
import { IoClose } from "react-icons/io5";
import { capitalizeString } from "../../../utility/formatter-helper";
import { RxLinkBreak1 } from "react-icons/rx";
import useServiceStatus from "../../../hooks/useServiceStatus";
import { RiLockFill } from "react-icons/ri";

function AiSuggestion() {
  const {
    tradeForm: {
      targetExchange,
      targetCoin,
      tradeType,
      step,
      targetPortfolioStatus,
      aiSuggestionStatus,
    },
    main: { userData },
  } = useSelector((state) => state);

  const { isActive: isAiAssistantActive } = useServiceStatus("aiAssistant");
  const { isActive: isInsightActive } = useServiceStatus("insight");

  const isActive = isAiAssistantActive || isInsightActive;

  const controllerRef = useRef(null);

  const {
    isLoading,
    tp_percent,
    sl_percent,
    prediction,
    isError,
    error,
    date,
    confidence,
    applyAllSuggestion,
    positionSize,
    signalColor,
  } = useAISuggestion();

  const disabled = isLoading || !targetExchange || !targetCoin;

  const dispatch = useDispatch();

  const getSuggestion = () => {
    // if (!isActive) return message.info("Activate AI service first!");
    if (!targetCoin) return message.info("Please select an asset first");

    // Create a new AbortController
    controllerRef.current = new AbortController();
    const { signal } = controllerRef.current;

    const exchange =
      targetExchange === "cryptocrispy" || targetExchange === "swyftx"
        ? "binance"
        : targetExchange;

    return dispatch(
      getAISuggestion(
        userData?.["custom:custom_username"],
        userData?.["cognito:username"],
        exchange,
        targetCoin,
        false,
        signal,
      ),
    );
  };

  const cancelSuggestion = () => {
    if (controllerRef.current) {
      controllerRef.current.abort();
    }
  };

  // console.log(tp_percent, sl_percent, prediction, isError, error);

  return (
    <div className={styles.suggestionContainer}>
      <div className={styles.suggestionBtns}>
        <Button
          onClick={getSuggestion}
          className={styles.aiBtn}
          loading={isLoading}
          disabled={disabled}
        >
          {/*{!isLoading && <LuBrainCircuit />}*/}
          {/*{!isActive && <RiLockFill />}*/}
          AI Trade Suggestion
        </Button>

        <div className={styles.suggestionHandlers}>
          {isLoading && (
            <span className={styles.cancelSuggestion}>
              <IoClose onClick={cancelSuggestion} size={16} />
            </span>
          )}
          {!isLoading && (prediction || error) && (
            <span className={styles.retrySuggestion} onClick={getSuggestion}>
              <MdRefresh size={16} color="white" />
            </span>
          )}
        </div>
      </div>

      {error && !isLoading && (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
            gap: ".5rem",
            marginTop: ".5rem",
          }}
        >
          <RxLinkBreak1 size={25} color="#bdc3c7" />
          <p
            style={{ fontSize: "12px", color: "#e84118", textAlign: "center" }}
          >
            Something went wrong. Retry!
          </p>
        </div>
      )}

      {aiSuggestionStatus === "pending" && !isLoading && (
        <p
          style={{
            fontSize: "12px",
            textAlign: "center",
            marginTop: ".5rem",
            color: "#0c4cfc",
          }}
        >
          The AI is updating. Try later!
        </p>
      )}

      {/*{error && !isLoading && <Empty className={styles.noSuggestion} />}*/}
      {prediction && !!sl_percent && targetCoin && (
        <div className={styles.suggestionInfo}>
          <Tooltip
            title={
              <>
                {tradeType !== "sell" && (
                  <>
                    <span>SL: {(sl_percent * 100)?.toFixed(2)}% </span>
                    <br />
                    <span>TP: {(tp_percent * 100)?.toFixed(2)}% </span>
                    <br />
                  </>
                )}
                <span>Position Size: {positionSize * 100}%</span>
                {/*<br />*/}
                {/*<span>Confidence: {confidence * 100}%</span>*/}
              </>
            }
            placement="top"
            color="geekblue"
          >
            <MdInfo color="#0c4cfc" style={{ marginRight: ".2rem" }} />
            <span
              style={{
                color: `${signalColor}`,
                fontWeight: 900,
              }}
            >
              {capitalizeString(prediction)}
            </span>
            ,{" "}
            <span
              style={{
                color: `${signalColor}`,
                fontWeight: 900,
              }}
            >
              {date}
            </span>
          </Tooltip>
          {step !== 1 && (
            <span
              className={styles.applyAllSuggestion}
              onClick={applyAllSuggestion}
            >
              Apply All
            </span>
          )}
        </div>
      )}

      {/*<LuBrainCircuit className={styles.suggestionIcon} />*/}
      {/*<FaBrain className={styles.suggestionIcon} color="#0c4cfc" size={20} />*/}
      {(!targetCoin || targetPortfolioStatus === "loading") && (
        <div className={styles.mask}></div>
      )}
    </div>
  );
}

export default AiSuggestion;
